module.exports = "/_next/static/images/support-712b7ab1c908e2e4cc77df3b6fb0e6ef.svg";